"use strict";
/**
 * This code was GENERATED using the solita package.
 * Please DO NOT EDIT THIS FILE, instead rerun solita to update it or write a wrapper to add functionality.
 *
 * See: https://github.com/metaplex-foundation/solita
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.InvalidCleanError = exports.InvalidEvictError = exports.TooManyGlobalSeatsError = exports.InvalidMintError = exports.IncorrectAccountError = exports.GlobalInsufficientError = exports.MissingGlobalError = exports.OverflowError = exports.OrderTooSmallError = exports.OrderWouldOverflowError = exports.PriceNotPositiveError = exports.WrongIndexHintParamsError = exports.InvalidPlaceOrderFromWalletParamsError = exports.InsufficientOutError = exports.AlreadyExpiredError = exports.PostOnlyCrossesError = exports.AlreadyClaimedSeatError = exports.InvalidFreeListError = exports.InvalidCancelError = exports.InvalidWithdrawAccountsError = exports.InvalidDepositAccountsError = exports.InvalidMarketParametersError = void 0;
exports.errorFromCode = errorFromCode;
exports.errorFromName = errorFromName;
const createErrorFromCodeLookup = new Map();
const createErrorFromNameLookup = new Map();
/**
 * InvalidMarketParameters: 'Invalid market parameters error'
 *
 * @category Errors
 * @category generated
 */
class InvalidMarketParametersError extends Error {
    code = 0x0;
    name = 'InvalidMarketParameters';
    constructor() {
        super('Invalid market parameters error');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidMarketParametersError);
        }
    }
}
exports.InvalidMarketParametersError = InvalidMarketParametersError;
createErrorFromCodeLookup.set(0x0, () => new InvalidMarketParametersError());
createErrorFromNameLookup.set('InvalidMarketParameters', () => new InvalidMarketParametersError());
/**
 * InvalidDepositAccounts: 'Invalid deposit accounts error'
 *
 * @category Errors
 * @category generated
 */
class InvalidDepositAccountsError extends Error {
    code = 0x1;
    name = 'InvalidDepositAccounts';
    constructor() {
        super('Invalid deposit accounts error');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidDepositAccountsError);
        }
    }
}
exports.InvalidDepositAccountsError = InvalidDepositAccountsError;
createErrorFromCodeLookup.set(0x1, () => new InvalidDepositAccountsError());
createErrorFromNameLookup.set('InvalidDepositAccounts', () => new InvalidDepositAccountsError());
/**
 * InvalidWithdrawAccounts: 'Invalid withdraw accounts error'
 *
 * @category Errors
 * @category generated
 */
class InvalidWithdrawAccountsError extends Error {
    code = 0x2;
    name = 'InvalidWithdrawAccounts';
    constructor() {
        super('Invalid withdraw accounts error');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidWithdrawAccountsError);
        }
    }
}
exports.InvalidWithdrawAccountsError = InvalidWithdrawAccountsError;
createErrorFromCodeLookup.set(0x2, () => new InvalidWithdrawAccountsError());
createErrorFromNameLookup.set('InvalidWithdrawAccounts', () => new InvalidWithdrawAccountsError());
/**
 * InvalidCancel: 'Invalid cancel error'
 *
 * @category Errors
 * @category generated
 */
class InvalidCancelError extends Error {
    code = 0x3;
    name = 'InvalidCancel';
    constructor() {
        super('Invalid cancel error');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidCancelError);
        }
    }
}
exports.InvalidCancelError = InvalidCancelError;
createErrorFromCodeLookup.set(0x3, () => new InvalidCancelError());
createErrorFromNameLookup.set('InvalidCancel', () => new InvalidCancelError());
/**
 * InvalidFreeList: 'Internal free list corruption error'
 *
 * @category Errors
 * @category generated
 */
class InvalidFreeListError extends Error {
    code = 0x4;
    name = 'InvalidFreeList';
    constructor() {
        super('Internal free list corruption error');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidFreeListError);
        }
    }
}
exports.InvalidFreeListError = InvalidFreeListError;
createErrorFromCodeLookup.set(0x4, () => new InvalidFreeListError());
createErrorFromNameLookup.set('InvalidFreeList', () => new InvalidFreeListError());
/**
 * AlreadyClaimedSeat: 'Cannot claim a second seat for the same trader'
 *
 * @category Errors
 * @category generated
 */
class AlreadyClaimedSeatError extends Error {
    code = 0x5;
    name = 'AlreadyClaimedSeat';
    constructor() {
        super('Cannot claim a second seat for the same trader');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, AlreadyClaimedSeatError);
        }
    }
}
exports.AlreadyClaimedSeatError = AlreadyClaimedSeatError;
createErrorFromCodeLookup.set(0x5, () => new AlreadyClaimedSeatError());
createErrorFromNameLookup.set('AlreadyClaimedSeat', () => new AlreadyClaimedSeatError());
/**
 * PostOnlyCrosses: 'Matched on a post only order'
 *
 * @category Errors
 * @category generated
 */
class PostOnlyCrossesError extends Error {
    code = 0x6;
    name = 'PostOnlyCrosses';
    constructor() {
        super('Matched on a post only order');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, PostOnlyCrossesError);
        }
    }
}
exports.PostOnlyCrossesError = PostOnlyCrossesError;
createErrorFromCodeLookup.set(0x6, () => new PostOnlyCrossesError());
createErrorFromNameLookup.set('PostOnlyCrosses', () => new PostOnlyCrossesError());
/**
 * AlreadyExpired: 'New order is already expired'
 *
 * @category Errors
 * @category generated
 */
class AlreadyExpiredError extends Error {
    code = 0x7;
    name = 'AlreadyExpired';
    constructor() {
        super('New order is already expired');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, AlreadyExpiredError);
        }
    }
}
exports.AlreadyExpiredError = AlreadyExpiredError;
createErrorFromCodeLookup.set(0x7, () => new AlreadyExpiredError());
createErrorFromNameLookup.set('AlreadyExpired', () => new AlreadyExpiredError());
/**
 * InsufficientOut: 'Less than minimum out amount'
 *
 * @category Errors
 * @category generated
 */
class InsufficientOutError extends Error {
    code = 0x8;
    name = 'InsufficientOut';
    constructor() {
        super('Less than minimum out amount');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InsufficientOutError);
        }
    }
}
exports.InsufficientOutError = InsufficientOutError;
createErrorFromCodeLookup.set(0x8, () => new InsufficientOutError());
createErrorFromNameLookup.set('InsufficientOut', () => new InsufficientOutError());
/**
 * InvalidPlaceOrderFromWalletParams: 'Invalid place order from wallet params'
 *
 * @category Errors
 * @category generated
 */
class InvalidPlaceOrderFromWalletParamsError extends Error {
    code = 0x9;
    name = 'InvalidPlaceOrderFromWalletParams';
    constructor() {
        super('Invalid place order from wallet params');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidPlaceOrderFromWalletParamsError);
        }
    }
}
exports.InvalidPlaceOrderFromWalletParamsError = InvalidPlaceOrderFromWalletParamsError;
createErrorFromCodeLookup.set(0x9, () => new InvalidPlaceOrderFromWalletParamsError());
createErrorFromNameLookup.set('InvalidPlaceOrderFromWalletParams', () => new InvalidPlaceOrderFromWalletParamsError());
/**
 * WrongIndexHintParams: 'Index hint did not match actual index'
 *
 * @category Errors
 * @category generated
 */
class WrongIndexHintParamsError extends Error {
    code = 0xa;
    name = 'WrongIndexHintParams';
    constructor() {
        super('Index hint did not match actual index');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, WrongIndexHintParamsError);
        }
    }
}
exports.WrongIndexHintParamsError = WrongIndexHintParamsError;
createErrorFromCodeLookup.set(0xa, () => new WrongIndexHintParamsError());
createErrorFromNameLookup.set('WrongIndexHintParams', () => new WrongIndexHintParamsError());
/**
 * PriceNotPositive: 'Price is not positive'
 *
 * @category Errors
 * @category generated
 */
class PriceNotPositiveError extends Error {
    code = 0xb;
    name = 'PriceNotPositive';
    constructor() {
        super('Price is not positive');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, PriceNotPositiveError);
        }
    }
}
exports.PriceNotPositiveError = PriceNotPositiveError;
createErrorFromCodeLookup.set(0xb, () => new PriceNotPositiveError());
createErrorFromNameLookup.set('PriceNotPositive', () => new PriceNotPositiveError());
/**
 * OrderWouldOverflow: 'Order settlement would overflow'
 *
 * @category Errors
 * @category generated
 */
class OrderWouldOverflowError extends Error {
    code = 0xc;
    name = 'OrderWouldOverflow';
    constructor() {
        super('Order settlement would overflow');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, OrderWouldOverflowError);
        }
    }
}
exports.OrderWouldOverflowError = OrderWouldOverflowError;
createErrorFromCodeLookup.set(0xc, () => new OrderWouldOverflowError());
createErrorFromNameLookup.set('OrderWouldOverflow', () => new OrderWouldOverflowError());
/**
 * OrderTooSmall: 'Order is too small to settle any value'
 *
 * @category Errors
 * @category generated
 */
class OrderTooSmallError extends Error {
    code = 0xd;
    name = 'OrderTooSmall';
    constructor() {
        super('Order is too small to settle any value');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, OrderTooSmallError);
        }
    }
}
exports.OrderTooSmallError = OrderTooSmallError;
createErrorFromCodeLookup.set(0xd, () => new OrderTooSmallError());
createErrorFromNameLookup.set('OrderTooSmall', () => new OrderTooSmallError());
/**
 * Overflow: 'Overflow in token addition'
 *
 * @category Errors
 * @category generated
 */
class OverflowError extends Error {
    code = 0xe;
    name = 'Overflow';
    constructor() {
        super('Overflow in token addition');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, OverflowError);
        }
    }
}
exports.OverflowError = OverflowError;
createErrorFromCodeLookup.set(0xe, () => new OverflowError());
createErrorFromNameLookup.set('Overflow', () => new OverflowError());
/**
 * MissingGlobal: 'Missing Global account'
 *
 * @category Errors
 * @category generated
 */
class MissingGlobalError extends Error {
    code = 0xf;
    name = 'MissingGlobal';
    constructor() {
        super('Missing Global account');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, MissingGlobalError);
        }
    }
}
exports.MissingGlobalError = MissingGlobalError;
createErrorFromCodeLookup.set(0xf, () => new MissingGlobalError());
createErrorFromNameLookup.set('MissingGlobal', () => new MissingGlobalError());
/**
 * GlobalInsufficient: 'Insufficient funds on global account to rest an order'
 *
 * @category Errors
 * @category generated
 */
class GlobalInsufficientError extends Error {
    code = 0x10;
    name = 'GlobalInsufficient';
    constructor() {
        super('Insufficient funds on global account to rest an order');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, GlobalInsufficientError);
        }
    }
}
exports.GlobalInsufficientError = GlobalInsufficientError;
createErrorFromCodeLookup.set(0x10, () => new GlobalInsufficientError());
createErrorFromNameLookup.set('GlobalInsufficient', () => new GlobalInsufficientError());
/**
 * IncorrectAccount: 'Account key did not match expected'
 *
 * @category Errors
 * @category generated
 */
class IncorrectAccountError extends Error {
    code = 0x11;
    name = 'IncorrectAccount';
    constructor() {
        super('Account key did not match expected');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, IncorrectAccountError);
        }
    }
}
exports.IncorrectAccountError = IncorrectAccountError;
createErrorFromCodeLookup.set(0x11, () => new IncorrectAccountError());
createErrorFromNameLookup.set('IncorrectAccount', () => new IncorrectAccountError());
/**
 * InvalidMint: 'Mint not allowed for market'
 *
 * @category Errors
 * @category generated
 */
class InvalidMintError extends Error {
    code = 0x12;
    name = 'InvalidMint';
    constructor() {
        super('Mint not allowed for market');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidMintError);
        }
    }
}
exports.InvalidMintError = InvalidMintError;
createErrorFromCodeLookup.set(0x12, () => new InvalidMintError());
createErrorFromNameLookup.set('InvalidMint', () => new InvalidMintError());
/**
 * TooManyGlobalSeats: 'Cannot claim a new global seat, use evict'
 *
 * @category Errors
 * @category generated
 */
class TooManyGlobalSeatsError extends Error {
    code = 0x13;
    name = 'TooManyGlobalSeats';
    constructor() {
        super('Cannot claim a new global seat, use evict');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, TooManyGlobalSeatsError);
        }
    }
}
exports.TooManyGlobalSeatsError = TooManyGlobalSeatsError;
createErrorFromCodeLookup.set(0x13, () => new TooManyGlobalSeatsError());
createErrorFromNameLookup.set('TooManyGlobalSeats', () => new TooManyGlobalSeatsError());
/**
 * InvalidEvict: 'Can only evict the lowest depositor'
 *
 * @category Errors
 * @category generated
 */
class InvalidEvictError extends Error {
    code = 0x14;
    name = 'InvalidEvict';
    constructor() {
        super('Can only evict the lowest depositor');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidEvictError);
        }
    }
}
exports.InvalidEvictError = InvalidEvictError;
createErrorFromCodeLookup.set(0x14, () => new InvalidEvictError());
createErrorFromNameLookup.set('InvalidEvict', () => new InvalidEvictError());
/**
 * InvalidClean: 'Tried to clean order that was not eligible to be cleaned'
 *
 * @category Errors
 * @category generated
 */
class InvalidCleanError extends Error {
    code = 0x15;
    name = 'InvalidClean';
    constructor() {
        super('Tried to clean order that was not eligible to be cleaned');
        if (typeof Error.captureStackTrace === 'function') {
            Error.captureStackTrace(this, InvalidCleanError);
        }
    }
}
exports.InvalidCleanError = InvalidCleanError;
createErrorFromCodeLookup.set(0x15, () => new InvalidCleanError());
createErrorFromNameLookup.set('InvalidClean', () => new InvalidCleanError());
/**
 * Attempts to resolve a custom program error from the provided error code.
 * @category Errors
 * @category generated
 */
function errorFromCode(code) {
    const createError = createErrorFromCodeLookup.get(code);
    return createError != null ? createError() : null;
}
/**
 * Attempts to resolve a custom program error from the provided error name, i.e. 'Unauthorized'.
 * @category Errors
 * @category generated
 */
function errorFromName(name) {
    const createError = createErrorFromNameLookup.get(name);
    return createError != null ? createError() : null;
}
